import React, { useState } from 'react';
import Modal from 'react-modal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import '../styles/certificates.css'; // Optional for styling

import cert2 from '../assets/images/Blue_nest_cirteficate_1.jpg';
import cert5 from '../assets/images/Blue_nest_cirteficate_2.jpg';
import cert1 from '../assets/images/Blue_nest_cirteficate_3.jpg';
import cert3 from '../assets/images/Blue_nest_cirteficate_4.jpg';
import cert4 from '../assets/images/Blue_nest_cirteficate_5.jpg';
import cert6 from '../assets/images/Blue_nest_cirteficate_6.jpg';
import cert7 from '../assets/images/Blue_nest_cirteficate_7.jpg';
import cert8 from '../assets/images/Blue_nest_cirteficate_8.jpg';
import cert9 from '../assets/images/Blue_nest_cirteficate_9.jpg';

const images = [cert1, cert2, cert3, cert4, cert5,cert6,cert7,cert8,cert9];



const RecognitionCertificates = ({ language }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (img) => {
    setSelectedImage(img);
    setModalOpen(true);
  };

  return (
    <section className="certificate-section py-5">
      <div className="container">
            <h1 className="text-center fw-bold mb-4" style={{ color: '#1e3a8a' }}>
  {language === 'am' ? 'የ እውቅና የምስከር ወረቀት' : 'Certificate of appreciation'}
</h1>
        <Swiper
          spaceBetween={30}
          slidesPerView={1}
          navigation
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Navigation]}
          className="certificates-swiper"
        >
          {images.map((img, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="certificate-slide"
                onClick={() => openModal(img)}
              >
                <img
                  src={img}
                  alt={`Certificate ${idx + 1}`}
                  className="img-fluid rounded shadow-sm"
                  style={{ 
                    cursor: 'pointer', 
                    height: '400px', 
                    width: '100%',
                    objectFit: 'contain',
                    backgroundColor: '#f8f9fa'
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          className="fullscreen-modal"
          overlayClassName="fullscreen-overlay"
        >
          <button
            onClick={() => setModalOpen(false)}
            className="modal-close-btn"
          >
            &times;
          </button>
          <img
            src={selectedImage}
            alt="Enlarged certificate"
            className="fullscreen-img"
          />
        </Modal>
      </div>
    </section>
  );
};

export default RecognitionCertificates;
